import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';
import queryString from 'query-string';

export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH';
export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH_SUCCESS = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH_SUCCESS';
export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH_FAILURE = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH_FAILURE';

export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_GET = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_GET';

export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_UPDATE = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_UPDATE';

export const ADMIN_ROUND_REPORT_STORAGE_ITEMS_SET_SEARCH_PARAMETERS = 'ADMIN_ROUND_REPORT_STORAGE_ITEMS_SET_SEARCH_PARAMETERS';

export const searchRoundReportStorageItems = searchParameters => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_ROUND_REPORT_STORAGE_ITEMS_SEARCH),
        endpoint: `/api/admin/roundReportStorageItems?${queryString.stringify(searchParameters)}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const getRoundReportStorageItem = roundReportStorageItemId => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_ROUND_REPORT_STORAGE_ITEMS_GET),
        endpoint: `/api/admin/roundReportStorageItems/${roundReportStorageItemId}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const updateRoundReportStorageItem = (roundReportStorageItemId, roundReportStorageItem) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_ROUND_REPORT_STORAGE_ITEMS_UPDATE),
        endpoint: `/api/admin/roundReportStorageItems/${roundReportStorageItemId}`,
        headers: createHeaders(true),
        method: 'PUT',
        body: JSON.stringify(roundReportStorageItem)
    }
});

export const setSearchParameters = searchParameters => ({
    type: ADMIN_ROUND_REPORT_STORAGE_ITEMS_SET_SEARCH_PARAMETERS,
    searchParameters
});
